/* eslint-disable indent, react/jsx-wrap-multilines */
import React, { useEffect, useState } from 'react';
import { connect } from 'umi';
import { Form, Input } from 'antd';
import { isEmpty } from 'lodash';
import { Text, Modal, Button } from '@digitalc/dxp-ui';
import { Popup, CheckList } from 'antd-mobile';
import { CloseOutlined } from '@ant-design/icons';
import styled from 'styled-components';
import { onHistoryPush } from '@/utils/utils';
import useResponsive from '@/hooks/useResponsive';
import useGCPI18n from '@/hooks/useGCPI18n';
import { Clickable } from '@/components';
import dorpDown from '@/assets/images/Group.png';
import convertFail from '@/assets/images/point/convertFail.png';
import Header from '../Header';
import styles from './index.less';

const InputContainer = styled.div`
  height: 100%;
  font-family: ${props => props.$dxpToken.fontFamilySecondaryRegular};
  .ant-input-affix-wrapper {
    border: 1px solid ${props => props.$dxpToken.colorBorderStandard};
    background-color: ${props => props.$dxpToken.colorBackgroundStandard};
    padding: 0rem ${props => props.$dxpToken.spacingInputMd / 100}rem;
  }
  .ant-input-disabled {
    background-color: ${props => props.$dxpToken.colorBackgroundSubtle};
  }
  .ant-form-item {
    margin-bottom: ${props => props.$dxpToken.spacingGapMd};
  }
`;
const PopupContainer = styled.div`
  .adm-list {
    --border-top: none;
  }
  .adm-list-item-content {
    padding-right: 0;
  }
  .adm-list-item {
    font-family: ${props => props.$dxpToken.fontFamilySecondaryRegular};
    color: ${props => props.$dxpToken.colorTextNeutral};
    padding-left: 0;
    font-weight: 400;
    line-height: 1.5;
    font-size: ${props => props.$dxpToken.fontSizeMobileContentC14 / 100}rem;
  }
  .adm-check-list-item-active {
    color: ${props => props.$dxpToken.colorBackgroundCta} !important;
    background-color: #fff;
  }
  .adm-list-item-content-main {
    padding: ${props => props.$dxpToken.spacingGapMd / 100}rem 0;
  }
  .adm-check-list-item-extra {
    color: ${props => props.$dxpToken.colorBackgroundCta} !important;
  }
  a.adm-list-item:active:not(.adm-list-item-disabled) {
    color: ${props => props.$dxpToken.colorBackgroundCta} !important;
    background-color: #fff;
  }
  .adm-list-item-content {
    padding-right: 0;
  }
`;
const PointsConversion = props => {
  // 响应式 hook
  useResponsive();
  const { conversionList, conversionPoint, getConfigParamDXP, dxpToken } = props;
  const GCPI18n = useGCPI18n();
  const [form] = Form.useForm();
  const [selectPointVisible, setSelectPointVisible] = useState(false);
  // 确认打开popup数据源
  const [pointType, setPointType] = useState('');
  const [disabled, setDisabled] = useState(true); // 按钮禁用
  const values = form.getFieldsValue();
  const [conversionVisible, setConversionVisible] = useState(false);
  const [hasFail, setHasFail] = useState(false);
  const [conversionPointList, setConversionPoinList] = useState([]);
  // destination 可选
  const [destinationPointList, setDestinationPoinList] = useState([]);
  const [destinationTempPointList, setDestinationTempPoinList] = useState([]);
  const [sourcePoint, setSourcePoint] = useState({});
  const [destinationPoint, setDestinationPoint] = useState({});
  const [tempsourcePoint, setTempSourcePoint] = useState({});
  const [tempdestinationPoint, setTempDestinationPoint] = useState({});
  const [displayScale, setDisplayScale] = useState(0);
  const rpointValue = Form.useWatch('redeemPointValue', form);
  const disPointValue = Form.useWatch('points', form);
  const [hintInfoVisible, setHintInfoVisible] = useState(false);
  const [hintInfo, setHintInfo] = useState('');
  const [pointsError, setPointsError] = useState(false);
  const selectPointType = type => {
    setSelectPointVisible(true);
    setPointType(type);
  };

  /**
   * Render a select input with dropdown icon
   * @param {Object} params - Form item configuration
   * @param {string} params.name - Form field name
   * @param {string} params.labelI18nId - Label i18n ID
   * @param {string} params.selectType - Type to pass to selectPointType ('source' or 'destination')
   */
  const renderSelectInput = ({ name, labelI18nId, selectType }) => (
    <Form.Item
      name={name}
      label={GCPI18n({ id: labelI18nId })}
      rules={[
        {
          required: true,
          message: GCPI18n({ id: 'lb_point_field_required' }),
        },
      ]}
    >
      <Input
        placeholder={GCPI18n({ id: 'lb_conversion_select' })}
        suffix={
          <Clickable as="img" src={dorpDown} alt="" onClick={() => selectPointType(selectType)} />
        }
        onClick={() => selectPointType(selectType)}
      />
    </Form.Item>
  );
  useEffect(() => {
    if (!isEmpty(values)) {
      const { sourcePointAcct, destPointAcct } = values;
      if (sourcePointAcct && destPointAcct && rpointValue) {
        setDisabled(false);
        const disPlayPointValue =
          (Number(rpointValue) / Number(destinationPoint?.pointValueInterval)) *
          Number(destinationPoint?.destPointValue);
        form.setFieldsValue({ points: parseFloat(disPlayPointValue).toFixed(displayScale) });
      } else {
        setDisabled(true);
        form.setFieldsValue({ points: '-' });
      }
    }
  }, [values, rpointValue]);
  useEffect(() => {
    conversionList().then(res => {
      if (res.resultCode === '0') {
        setConversionPoinList(res?.data || []);
        if (res?.data && res.data.length > 0) {
          setSourcePoint(res?.data[0]);
          setTempSourcePoint(res?.data[0]);
          setDestinationPoinList(res?.data[0]?.destPointAcctList || []);
          setDestinationTempPoinList(res?.data[0]?.destPointAcctList || []);
          form.setFieldsValue({ sourcePointAcct: res?.data[0]?.sourcePointAcctName });
        }
      }
    });
    getConfigParamDXP({ paramCodeList: ['lms.point.precision'] }).then(res => {
      const jsonObj = JSON.parse(res.paramValue);
      setDisplayScale(jsonObj?.displayScale || 0);
    });
  }, []);
  const handleConvert = async () => {
    const formInfo = await form.validateFields();
    if (isEmpty(formInfo)) return;
    setConversionVisible(true);
  };
  const handleSubmitPointClick = () => {
    const payload = {
      sourcePointAcct: sourcePoint?.sourcePointAcctCode,
      destPointAcct: destinationPoint?.destPointAcctCode,
      redeemPointValue: rpointValue,
    };
    conversionPoint(payload).then(res => {
      if (res.resultCode === '0') {
        setConversionVisible(false);
        onHistoryPush('/pointshop/SuccessPage', {
          type: 'Conversion',
          sourceName: sourcePoint?.sourcePointAcctName,
          sourcePoints: rpointValue,
          destinationPoints: disPointValue,
          destinationName: destinationPoint?.destPointAcctName,
        });
      } else {
        setConversionVisible(false);
        setHasFail(true);
      }
    });
  };
  const handleInputChange = e => {
    const { value } = e.target;
    form.setFieldsValue({ redeemPointValue: value });
  };

  const handleBlur = () => {
    const redeemPointValue = form.getFieldValue('redeemPointValue');
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(redeemPointValue) && redeemPointValue > 0) {
      form.setFieldsValue({ redeemPointValue: parseFloat(redeemPointValue).toFixed(displayScale) });
    }
  };
  useEffect(() => {
    if (!isEmpty(destinationPoint)) {
      setHintInfoVisible(true);
    } else {
      setHintInfoVisible(false);
    }
    const tempInfo = destinationPoint?.pointMaxValue
      ? `${GCPI18n({
          id: 'lb_conversion_moren_than',
        })} ${destinationPoint?.pointMinValue}${GCPI18n({
          id: 'lb_conversion_less_than',
        })} ${destinationPoint?.pointMaxValue}${GCPI18n({
          id: 'lb_conversion_multiple',
        })} ${destinationPoint?.pointValueInterval}${GCPI18n({
          id: 'lb_conversion_makes',
        })}`
      : `${GCPI18n({
          id: 'lb_conversion_moren_than',
        })} ${destinationPoint?.pointMinValue}${GCPI18n({
          id: 'lb_conversion_multiple',
        })} ${destinationPoint?.pointValueInterval}${GCPI18n({
          id: 'lb_conversion_makes',
        })}`;
    setHintInfo(tempInfo);
  }, [destinationPoint]);

  return (
    <InputContainer $dxpToken={dxpToken}>
      <div className={styles.pointsTransfer}>
        <Header
          title={GCPI18n({
            id: 'lb_conversion_points_to_convert',
          })}
        />
        <Form
          name="basic"
          autoComplete="off"
          form={form}
          colon={false}
          layout="vertical"
          style={{ color: dxpToken.colorTextNeutral }}
          // onValuesChange={handleFieldsChange}
        >
          {renderSelectInput({
            name: 'sourcePointAcct',
            labelI18nId: 'lb_converison_source_type',
            selectType: 'source',
          })}
          {renderSelectInput({
            name: 'destPointAcct',
            labelI18nId: 'lb_conversion_destination_points',
            selectType: 'destination',
          })}
          <Form.Item
            name="redeemPointValue"
            label={GCPI18n({
              id: 'lb_conversion_source_points',
            })}
            rules={[
              () => ({
                validator(_, value) {
                  try {
                    if (value && !isEmpty(destinationPoint)) {
                      // eslint-disable-next-line no-restricted-globals
                      if (isNaN(Number(value)) || Number(value) <= 0) {
                        setPointsError(true);
                        return Promise.reject(new Error(''));
                      }
                      if (Number(value) < Number(destinationPoint?.pointMinValue)) {
                        setPointsError(true);
                        return Promise.reject(new Error(''));
                      }
                      if (Number(value) % Number(destinationPoint?.pointValueInterval) !== 0) {
                        setPointsError(true);
                        return Promise.reject(new Error(''));
                      }
                      if (
                        destinationPoint?.pointMaxValue &&
                        Number(value) > Number(destinationPoint?.pointMaxValue)
                      ) {
                        setPointsError(true);
                        return Promise.reject(new Error(''));
                      }
                    }
                    setPointsError(false);
                    return Promise.resolve();
                  } catch (error) {
                    return Promise.resolve();
                  }
                },
              }),
            ]}
          >
            <Input
              placeholder={GCPI18n({
                id: 'lb_conversion_enter_info',
              })}
              onBlur={handleBlur}
              onChange={handleInputChange}
            />
          </Form.Item>
          {hintInfoVisible && (
            <div
              style={{
                marginBottom: `${dxpToken.spacingGapMd / 100}rem`,
                marginTop: `${-(dxpToken.spacingGapMd - dxpToken.spacingTextXs) / 100}rem`,
              }}
            >
              <Text
                breakpoint="Mobile"
                size="ContentC12Regular"
                style={{
                  color: pointsError ? dxpToken.colorTextAlert : dxpToken.colorTextHintMessage,
                }}
              >
                {' '}
                {hintInfo}
              </Text>
            </div>
          )}

          <Form.Item
            name="points"
            label={GCPI18n({
              id: 'lb_conversion_destination_points',
            })}
          >
            <Input
              disabled
              placeholder={GCPI18n({
                id: 'lb_conversion_enter_info',
              })}
            />
          </Form.Item>
        </Form>
        <div className={styles.orderFooter} style={{ padding: dxpToken.spacingGapLg }}>
          <div className={styles.footerBox}>
            <div className={styles.orderSubmit}>
              <Button block type="primary" onClick={handleConvert} disabled={disabled}>
                {GCPI18n({
                  id: 'lb_converison_convert',
                })}
              </Button>
            </div>
          </div>
          <Clickable
            style={{ marginTop: dxpToken.spacingIconMd, textAlign: 'center' }}
            // className={styles.footerCancel}
            onClick={() => {
              onHistoryPush('/pointshop/pointsH5');
            }}
          >
            <Text breakpoint="Mobile" size="ContentC14TextLink">
              {GCPI18n({
                id: 'btn_cancel',
              })}
            </Text>
          </Clickable>
        </div>
        {selectPointVisible && (
          <Popup
            visible={selectPointVisible}
            showCloseButton={false}
            bodyStyle={{
              borderTopLeftRadius: `${dxpToken.borderRadiusMd / 100}rem`,
              borderTopRightRadius: `${dxpToken.borderRadiusMd / 100}rem`,
              // padding: '0.24rem 0.16rem',
              padding: `${dxpToken.spacingGapLg / 100}rem ${dxpToken.spacingGapMd / 100}rem`,
              height: 'auto',
              maxHeight: '100% ',
            }}
          >
            <PopupContainer $dxpToken={dxpToken}>
              <div className={styles.content}>
                {/* <popupContainer> */}
                <div className={styles.popupHeader}>
                  <div
                    className={styles.title}
                    style={{
                      fontFamily: dxpToken.fontFamilyPromaryBold,
                      color: dxpToken.colorTextNeutral,
                      fontSize: dxpToken.fontSizeMobileTitleT21,
                    }}
                  >
                    {pointType === 'source'
                      ? GCPI18n({ id: 'lb_converison_source' })
                      : GCPI18n({ id: 'lb_converison_destination' })}
                  </div>
                  <CloseOutlined
                    style={{ fontSize: '0.24rem' }}
                    onClick={() => {
                      setSelectPointVisible(false);
                    }}
                  />
                </div>
                {pointType === 'source' ? (
                  <CheckList
                    style={{
                      margin: `${dxpToken.spacingGapLg / 100}rem 0`,
                    }}
                    defaultValue={[sourcePoint?.sourcePointAcctCode]}
                    onChange={val => {
                      // 只有confirm才生效
                      const tempList = conversionPointList.filter(
                        item => item?.sourcePointAcctCode === val[0],
                      );
                      setDestinationTempPoinList(tempList[0]?.destPointAcctList);
                      // setSourcePoint(tempList[0]);
                      setTempSourcePoint(tempList[0]);
                    }}
                  >
                    {conversionPointList.map(item => (
                      <CheckList.Item
                        key={item?.sourcePointAcctCode}
                        value={item?.sourcePointAcctCode}
                      >
                        {item?.sourcePointAcctName}
                      </CheckList.Item>
                    ))}
                  </CheckList>
                ) : (
                  <CheckList
                    style={{ margin: `${dxpToken.spacingGapLg / 100}rem 0` }}
                    defaultValue={[destinationPoint?.destPointAcctCode]}
                    onChange={val => {
                      const tempList = destinationPointList.filter(
                        item => item?.destPointAcctCode === val[0],
                      );
                      // setDestinationPoint(tempList[0]);
                      setTempDestinationPoint(tempList[0]);
                    }}
                  >
                    {destinationPointList.map(item => (
                      <CheckList.Item key={item?.destPointAcctCode} value={item?.destPointAcctCode}>
                        {item?.destPointAcctName}
                      </CheckList.Item>
                    ))}
                  </CheckList>
                )}
                <div className={styles.confirmBtn}>
                  <Button
                    type="primary"
                    block
                    onClick={() => {
                      if (pointType === 'source') {
                        form.setFieldsValue({ destPointAcct: null });
                        setHintInfoVisible(false);
                        setDestinationPoinList(destinationTempPointList);
                        setSourcePoint({ ...tempsourcePoint });
                        form.setFieldsValue({
                          sourcePointAcct: tempsourcePoint?.sourcePointAcctName,
                        });
                      }
                      if (pointType === 'destination') {
                        setDestinationPoint({ ...tempdestinationPoint });
                        form.setFieldsValue({
                          destPointAcct: tempdestinationPoint?.destPointAcctName,
                        });
                      }
                      setSelectPointVisible(false);
                    }}
                  >
                    {GCPI18n({
                      id: 'btn_confirm',
                    })}
                  </Button>
                </div>
                {/* </popupContainer> */}
              </div>
            </PopupContainer>
          </Popup>
        )}
        {conversionVisible && (
          <Modal
            breakpoint="mobile"
            size="50%"
            title={GCPI18n({ id: 'lb_conversion_points_to_convert' })}
            open={conversionVisible}
            onCancel={() => {
              setConversionVisible(false);
            }}
            // loading={modalLoading}
            footer={
              <div style={{ display: 'flex', gap: '0.1rem' }}>
                <Button
                  className={styles.cancel}
                  onClick={() => {
                    setConversionVisible(false);
                  }}
                >
                  {GCPI18n({ id: 'btn_cancel' })}
                </Button>
                <Button type="primary" onClick={handleSubmitPointClick} className={styles.primary}>
                  {GCPI18n({ id: 'lb_converison_convert' })}
                </Button>
              </div>
            }
          >
            <Text breakpoint="Mobile" size="ContentC14Regular">
              {GCPI18n('lb_converison_convert_tips', {
                rpointValue,
                sourcePointAcctName: sourcePoint?.sourcePointAcctName,
                disPointValue,
                destPointAcctName: destinationPoint?.destPointAcctName,
              })}
            </Text>
          </Modal>
        )}
        {hasFail && (
          <Modal
            breakpoint="mobile"
            size="50%"
            open={hasFail}
            onCancel={() => {
              setHasFail(false);
            }}
            // loading={modalLoading}
            className={styles.pointsModal}
            footer={
              <div style={{ display: 'flex', gap: '0.08rem' }}>
                <Button
                  className={styles.cancel}
                  onClick={() => {
                    onHistoryPush('/pointshop/pointsH5');
                  }}
                >
                  {GCPI18n({ id: 'lb_point_point_mall' })}
                </Button>
                <Button
                  type="primary"
                  onClick={() => {
                    // onHistoryPush('/pointshop/pointsConversion');
                    setHasFail(false);
                  }}
                  className={styles.primary}
                  style={{ color: '#ffffff' }}
                >
                  {GCPI18n({ id: 'lb_dito_failed_page_try_again' })}
                </Button>
              </div>
            }
            // className={styles.pointsModal} open footer={null} centered closable={false}
          >
            <div className={styles.contentWrap}>
              <div className={styles.errImg}>
                <img src={convertFail} alt="" />
              </div>
              <div style={{ textAlign: 'center' }}>
                <Text breakpoint="Mobile" size="TitleT23Bold" style={{ fontFamily: 'Roboto' }}>
                  {GCPI18n({ id: 'lb_conversion_fail' })}
                </Text>
              </div>
            </div>
          </Modal>
        )}
      </div>
    </InputContainer>
  );
};

const mapDispatchToProps = dispatch => ({
  conversionList: payload =>
    dispatch({
      type: 'pointShop/conversionList',
      payload,
    }),
  conversionPoint: payload =>
    dispatch({
      type: 'pointShop/conversionPoint',
      payload,
    }),
  getConfigParamDXP: payload =>
    dispatch({
      type: 'index/getConfigParamDXP',
      payload,
    }),
});

export default connect(
  ({ pointShop, loading, index }) => ({
    changeHis: pointShop.changeHis,
    pointDetail: pointShop.pointDetail,
    dxpToken: index.dxpToken,
    loading: loading.effects['pointShop/conversionList'] || false,
  }),
  mapDispatchToProps,
)(PointsConversion);
